export default "__VITE_ASSET__BdAhws3V__"